<template>
  <view-page
      baseRoute="facilities.sections"
      entity="Section"
      :button-access="componentAccess"
      :model-entity="modelEntity"
      :model-id="id"
  >
    <template v-slot="{model}">
      <section-form
          v-if="model"
          :readonly="readonly"
          v-model="model"
          card-title="Details"
      />
    </template>

  </view-page>
</template>

<script>

import ViewPage from "@/views/components/Views/ViewPage";
import SectionForm from '@/views/pages/facilities/sections/SectionForm';
import ViewModelMixin from '../../../../components/mixins/ViewModelMixin';
import NotificationMixin from '../../../../components/mixins/NotificationMixin';

export default {
  name: "SectionView",
  components: {
    SectionForm,
    ViewPage,
  },
  mixins: [ViewModelMixin, NotificationMixin],
  data() {
    return {
      readonly: true,
      loading: false,
      modelEntity: this.$api.facilities.sections,
      componentAccess: {
        canEdit: {
          route: 'facilities.sections.edit',
          access: false,
        },
        canDelete: {
          route: 'facilities.sections.delete',
          access: false,
        },
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.sectionId;
    },
    title() {
      if (!this.model.Section) {
        return '';
      }

      return '<h2>Section: ' + this.model.Section + '</h2>';
    }
  },
};
</script>

<style scoped>

</style>
